'use strict';

/**
 * Directive: Drop-up or Drop-down based on screen position
 *
 * @note        Should be applied to the drop-down container (usually a btn-group)
 * @version     12.4.0 #756 MLIBJS-121 Add validation to export wdDropUpOrDown for ES6 usage
 *              8.1.0 #579 Create drop-up or drop-down directive
 *
 * @author      Ryan Sweeney <rsweeney@webduct.com>
 * @author      Erik Orozco <eorozco@intersog.com>
 * @copyright   (c) 2017-2020 Build Centrix
 */
var wdDropUpOrDown = angular.module('wd.directives.dropups', [])
    .directive(
        'wdDropUpOrDown',
        function ($window)
        {
            return {
                restrict: 'A',
                link: function (scope, elm)
                {
                    elm.bind('click', function ($event) {

                        // Initially remove the dropup class until we know if we need it
                        angular.element(elm).removeClass('dropup');

                        var dropdownContainer   = $event.currentTarget;
                        var position            = dropdownContainer.getBoundingClientRect().top;
                        var buttonHeight        = dropdownContainer.getBoundingClientRect().height;
                        var dropdownMenu        = angular.element($(dropdownContainer)).find('.dropdown-menu');
                        var menuHeight          = dropdownMenu.outerHeight();
                        var $win                = angular.element($window);

                        if(!!(position > menuHeight && $win.height() - position < buttonHeight + menuHeight)) {

                            // Add dropup class
                            angular.element(elm).addClass('dropup');

                        }


                    });

                }
            };

        });
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdDropUpOrDown;
}        
//EOF